var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.locationInviteConfirmed ? _c('LocationInviteConfirmed', {
    attrs: {
      "confirmationId": _vm.id
    },
    on: {
      "close": _vm.goToDashboard
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }